import React from "react";

/**
 * The shared frame for the four landing-page service glyphs.
 *
 * Hand-drawn rather than pulled from `@mui/icons-material`: the Material silhouettes are filled and
 * visibly heavier than the outline set the design calls for, and adding a second icon library for
 * four glyphs is not worth the dependency.
 *
 * `stroke="currentColor"` is what makes these themeable — the disc sets `color` and the glyph
 * inherits it, exactly like the `brand.*` wrappers in `src/components/Icons/`.
 */
export interface ServiceIconProps {
  /** Edge length in px. The disc that holds the icon decides this, not the icon. */
  size?: number;
}

const ServiceIconBase: React.FC<React.PropsWithChildren<ServiceIconProps>> = ({
  size = 40,
  children,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    // The label lives in the anchor text next to it, so the glyph is decoration and announcing it
    // would just make every service read twice.
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export default ServiceIconBase;
